import { experienceTypes } from "@/modules/ExperienceData";
import * as registry from "@/plugin/registry";
import RootPlugin from "@/plugin/RootPlugin";
import RecipePlugin from "@/plugin/RecipePlugin";
import ProductPlugin from "@/plugin/ProductPlugin";
import type ShopWindowConfig from "@/plugin/ShopWindowConfig";
import type { ExperienceState, PluginEvent } from "@/types/state";

/** What every plugin provides; the value hooks are optional. */
interface Plugin {
  init(state: ExperienceState): void;
  getShopWindowConfig(name: string): ShopWindowConfig | undefined;
  handleEvent(state: ExperienceState, e: PluginEvent): boolean;
  willSetValue?(state: ExperienceState, name: string, value: unknown): unknown;
  didSetValue?(state: ExperienceState, name: string, value: unknown): unknown;
}

const plugins: Plugin[] = [];

export function configure(state: ExperienceState) {
  let plugin: Plugin;

  clear();

  plugin = new RootPlugin();
  plugin.init(state);
  plugins.push(plugin);

  if (state.experienceData.type === experienceTypes.RECIPE) {
    plugin = new RecipePlugin();
    plugin.init(state);
    plugins.push(plugin);
  } else {
    plugin = new ProductPlugin();
    plugin.init(state);
    plugins.push(plugin);
  }
}

function clear() {
  plugins.length = 0;
  registry.clear();
}

export function getShopWindowConfig(
  name: string,
): ShopWindowConfig | undefined {
  for (let n = plugins.length - 1; n >= 0; n--) {
    const config = plugins[n].getShopWindowConfig(name);
    if (config) {
      return config;
    }
  }
}

// This happens before call the action to
// set the value. Values will always be set.
export function willSetValue(
  state: ExperienceState,
  name: string,
  value: unknown,
) {
  for (let n = plugins.length - 1; n >= 0; n--) {
    plugins[n].willSetValue?.(state, name, value);
  }
}

// This happens during the dispatch after th value has
// been changed in the store.
export function didSetValue(
  state: ExperienceState,
  name: string,
  value: unknown,
) {
  for (let n = plugins.length - 1; n >= 0; n--) {
    plugins[n].didSetValue?.(state, name, value);
  }
}

export function handleEvent(state: ExperienceState, e: PluginEvent) {
  for (let n = plugins.length - 1; n >= 0; n--) {
    plugins[n].handleEvent(state, e);
  }
}
